import { faMicrophone, faListCheck, faStar, faPen, faBullhorn, faUsers, faUsersViewfinder, faPeopleArrows, faFlag } from '@fortawesome/free-solid-svg-icons';

export const DEFAULT_ROLE_WIZARD_DATA = {
  isModalOpen: false,
  isUserAuthenticated: false,
  currentRoleId: null,
  currentStepIndex: 0,
  submissionStatus: 'idle',
  acceptedAcknowledgements: [],
  completedSteps: []
};

export const BETA_ROLES = [
// Founding 50
{
  id: "founding50",
  title: "Founding 50",
  subtitle: 'Elite & Competitive',
  isRegistrationOpen: true,
  discordInviteCode: 'cqPZBx7ThE',

  positioning: {
    tagline: "Elite architects of SFB",
    commitmentText: 'high commitment',
    introTeasers: ['battle, judge, & engage', 'top 50 earn free lifetime premium'],
    shortIntro: "The most exclusive and competitive beta role. Built for battlers ready to compete and engage on SFB at the highest level.",
    longIntro: "Founding 50 is the highest-commitment Beta Role for battlers who compete, judge, and lead quality standards every month. You will stress-test scoring systems, contribute feedback, and help refine systems before official launch. Performance is tracked across battles, judging, audience scorecards, and community activity. Members who sustain top-tier consistency through every phase earn official Founding 50 status, lifetime role premium, and permanent recognition as core architects of SFB culture."
},

  limits: {
    officialCap: 50,
    signupCap: 250
  },

  betaWindow: {
    durationMonths: 12,
    endCondition: "12_months_or_v1_launch"
  },

  flags: {
    isPerformanceBased: true,
    leaderboardEnabled: true,
    hasProvisionalPhase: true,
    discordRequired: true,
    automaticVerification: true
  },

  requirements: {
    phase1: {
      title: "Phase 1",
      subtitle: "closed beta",
      description: "First 90 Days",
      targets: {
        battling: {
          metric: "verses",
          minimumPerMonth: 5,
          stretchPerMonth: 7,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        judging: {
          metric: "scorecards",
          minimumPerMonth: 2,
          stretchPerMonth: 3,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        audience: {
          metric: "scorecards",
          minimumPerMonth: 24,
          stretchPerMonth: 36,
          completionThreshold: 0.9,
          timeframe: "total"
        },
        community: {
          metric: "comments",
          minimumPerMonth: 10,
          stretchPerMonth: 15,
          completionThreshold: 0.9,
          timeframe: "weekly"
        }
      }
    },
  
    phase2: {
      title: "Phase 2",
      subtitle: "open beta",
      description: "Remaining Beta",
      targets: {
        battling: {
          metric: "verses",
          minimumPerMonth: 3,
          stretchPerMonth: 5,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        judging: {
          metric: "scorecards",
          minimumPerMonth: 1,
          stretchPerMonth: 2,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        audience: {
          metric: "scorecards",
          minimumPerMonth: 60,
          stretchPerMonth: 90,
          completionThreshold: 0.9,
          timeframe: "total"
        },
        community: {
          metric: "comments",
          minimumPerMonth: 5,
          stretchPerMonth: 10,
          completionThreshold: 0.9,
          timeframe: "weekly"
        }
      }
    },
  
    phase3: {
      title: "Phase 3",
      subtitle: "open beta",
      description: "Last 90 Days",
      targets: {
        battling: {
          metric: "verses",
          minimumPerMonth: 5,
          stretchPerMonth: 7,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        judging: {
          metric: "scorecards",
          minimumPerMonth: 2,
          stretchPerMonth: 3,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        audience: {
          metric: "scorecards",
          minimumPerMonth: 24,
          stretchPerMonth: 36,
          completionThreshold: 0.9,
          timeframe: "total"
        },
        community: {
          metric: "comments",
          minimumPerMonth: 10,
          stretchPerMonth: 15,
          completionThreshold: 0.9,
          timeframe: "weekly"
        }
      }
    }
  },

  leaderboard: {
    scope: "founding50_only",
    metricsWeighted: [
      "battling",
      "judging",
      "audience",
      "community",
      "reputation"
    ],
    thresholdsProvisionalUntilClosedBeta: true
  },

  rewards: {
      shared: ["Special perks and bonuses based on community input"],
    
      provisional: {
        statusId: "founding_50_provisional",
        title: "Provisional",
        subtitle: "",
        description: "Provisional members unlock progressive premium while helping shape the platform.",

        recognitions: [
          "Provisional Founding 50 marker",
          "Recognition in beta channels"
        ],

        privileges: [
          "Influence features during beta",
          "Admin & Mod roles during beta"
        ],
    
        premiumUnlocks: [{
          phase: 'phase1',
          months: [1, 2, 3],
          rewards: [{
            type: 'premium',
            monthsLength: 12
          }]
        }, {
          phase: 'phase2',
          months: [4, 5, 6, 7, 8, 9],
          rewards: [{
            type: 'premium',
            monthsLength: 3
          }, {
            type: 'premium',
            monthsLength: 3
          }]
        }, {
          phase: 'phase3',
          months: [10, 11, 12],
          rewards: [{
            type: 'premium',
            monthsLength: 6
          }]
        }]
      },
    
      runnerUp: {
        statusId: "founding_50_runner_up",
        title: "Runner-Up",
        subtitle: '',
        description: "Runner-Ups keep earned premium time, permanent Hall of Fame recognition, and priority consideration for future leadership roles.",
    
        recognitions: [
          "Permanent profile marker",
          "Permanent Hall of Fame"
        ],

        privileges: [
          "Early access to future features",
          "Community leadership roles"
        ],
    
        premium: {
          monthsLength: 12,
          isProvisionalRetained: true,
          bonuses: [{
            monthsLength: 12,
            label: '12 months if all beta phases complete'
          }]
        }
      },
    
      official: {
        statusId: "founding_50_official",
        title: "Founding 50",
        subtitle: 'official',
        description: "Official Founding 50 status goes to the top 50 most consistent provisional members at beta close. Official members receive lifetime role premium, permanent identity markers, and ongoing influence in platform direction.",
    
        recognitions: [
          "Lifetime Founding 50 profile badge",
          "Founding 50 title in battle headers",
          "Permanent Hall of Fame placement",
          "Recognition in official platform launch announcement"
        ],

        privileges: [
          "Exclusive advisory feature polls",
          "Priority community leadership roles"
        ],
    
        premium: {
          monthsLength: -1,
          isProvisionalRetained: false,
          bonuses: []
        }
      }
    },

  progression: {
    provisionalQualification: "meet_first_3_month_requirements",
    officialSelection: {
      method: "top_50_most_consistently_active_at_beta_end",
      tieBreakers: ["completedBattles", "reputation", "judging", "earlierSignupDate"],
      evaluationMetrics: [
        "battling",
        "judging",
        "audience",
        "community",
        "reputation"
      ]
    },

    overflowHandling: {
      statusGranted: "founding_50_runner_up",
    }
  },

  verification: {
    trackingSources: [
      "platform_battle_activity",
      "platform_judging_activity",
      "audience_scorecard_tracking",
      "reputation_scores",
      "leaderboard_metrics"
    ],
    manualReviewRequired: false
  },

  cardMeta: {
    teasers: [
      "Lifetime premium",
      "Lifetime recognition"
    ],
    highlights: [
      "50 Spots",
      "Commitment",
      "Performance"
    ],
    expectations: [{
      key: "battling",
      label: "Battling",
      icon: faMicrophone
    },
    {
      key: "judging",
      label: "Judging",
      icon: faListCheck
    },
    {
      key: "community",
      label: "Engagement",
      icon: faUsers
    },
    {
      key: "feedback",
      label: "Feedback",
      icon: faStar
    }]
  },

  confirmationMeta: {
    summaryPoints: [{
        title: "12-Month Performance Role",
        description: "12-month elite performance role"
      }, {
        title: "Leaderboard Tracking",
        description: "Activity tracked on dedicated leaderboard"
      }, {
        title: "Top 50 Selection",
        description: "Top 50 earn official status"
      }, {
        title: "Permanent Rewards",
        description: "Permanent recognition & lifetime premium"
    }],
    coreObligations: [{
        title: "Battle Participation",
        description: "Hit monthly battle targets"
      }, {
        title: "Official Judging",
        description: "Complete official judging targets"
      }, {
        title: "Audience Scoring",
        description: "Submit audience scorecards"
      }, {
        title: "Community Engagement",
        description: "Maintain weekly engagement"
      }, {
        title: "Discord Involvement",
        description: "Stay active in Discord"
    }],
  },

  requiredAcknowledgements: [
    {
      id: 'commitmentPerformanceV1',
      label: 'I understand rewards start at 3 months and status is earned through consistent performance.'
    },
    {
      id: 'trackingAndEligibilityV1',
      label: 'I understand leaderboards track eligibility, contribution, and progression.'
    },
    {
      id: 'communityEngagementV1',
      label: 'I will stay active, contribute to discussions, and participate in Discord during beta.'
    },
    {
      id: 'requirementsAndStatusV1',
      label: 'I understand requirements may evolve and final status depends on performance across all metrics.'
    }
  ],

  registrationSteps: [{
    stepId: 'founding50Overview',
    title: 'Role Overview',
    shortTitle: 'Overview',
    description: 'The highest-commitment role in SFB beta for battlers and judges shaping standards, systems, and culture.',
    isBlocking: true,
    contentRendererKey: 'RoleOverviewContent',
    requiredAcknowledgements: [{
      id: 'commitmentV1',
      label: 'I understand this is a performance-based 12-month commitment.'
    }]
  }, {
    stepId: 'founding50Requirements',
    title: 'Requirements',
    shortTitle: 'Requirements',
    description: 'Review exact thresholds for battles, judging, scorecards, and weekly engagement across all beta phases.',
    isBlocking: true,
    contentRendererKey: 'RoleRequirementsContent',
    requiredAcknowledgements: [{
        id: 'eligibilityV1',
        label: 'I understand verse totals determine eligibility.'
      }, {
        id: 'scoringV1',
        label: 'I understand official judging and audience scorecards are tracked separately.'
      }, {
        id: 'communityV1',
        label: 'I commit to consistent community engagement.'
      }, {
        id: 'readAllV1',
        label: 'I have read and understand all requirements'
      }, {
        id: 'finalStatusV1', 
        label: 'I understand final status is determined by leaderboard performance'
      }, {
        id: 'discordV1',
        label: 'I agree to participate in Discord during beta'
      }, {
        id: 'thresholdAdjustmentsV1',
        label: 'I understand thresholds may be adjusted before closed beta launch'
      }
    ]
  }, {
    stepId: 'founding50Rewards',
    title: 'Rewards & Status',
    shortTitle: 'Rewards',
    description: 'Review how provisional, runner-up, and official status are awarded and how premium unlocks accumulate.',
    isBlocking: true,
    contentRendererKey: 'RoleRewardsContent',
    requiredAcknowledgements: [{
      id: 'performanceV1',
      label: 'I understand official status is earned based on performance.'
    }]
  }, {
    stepId: 'founding50Confirm',
    title: 'Final Confirmation',
    shortTitle: 'Confirmation',
    description: "Confirm sustained performance, Discord participation, and leaderboard-based final status.",
    isBlocking: true,
    contentRendererKey: 'RoleConfirmationContent',
    requiredAcknowledgements: [{
      id: 'readAllV1',
      label: 'I have read and understand all requirements'
    }, {
      id: 'finalStatusV1', 
      label: 'I understand final status is determined by leaderboard performance'
    }, {
      id: 'discordV1',
      label: 'I agree to participate in Discord during beta'
    }, {
      id: 'thresholdAdjustmentsV1',
      label: 'I understand thresholds may be adjusted before closed beta launch'
    }]
  }]
},

// Day Ones
{
  id: "dayOnes",
  title: "Day Ones",
  subtitle: 'High-Impact',
  isRegistrationOpen: true,
  discordInviteCode: 'f8Fjm3hhRp',

  positioning: {
    tagline: "Core voices of beta",
    commitmentText: 'moderate commitment',
    introTeasers: ['watch, judge, & engage', 'top 250 earn free lifetime premium'],
    shortIntro: 'An exclusive high-participation beta role. Built for those ready to stay active and help shape SFB from day one.',
    longIntro: "Day Ones are core early adopters who help stabilize SFB through consistent activity and practical feedback. Members support scoring calibration, strengthen community standards, and grow platform momentum by staying active across battles, judging, audience scorecards, and discussion channels. This role rewards discipline across the full beta cycle. Members who sustain strong consistency earn official Day One status, lifetime role premium, and permanent recognition for helping shape SFB before full launch."
  },

  limits: {
    officialCap: 250,
    signupCap: 500
  },

  betaWindow: {
    durationMonths: 12,
    endCondition: "12_months_or_v1_launch"
  },

  flags: {
    isPerformanceBased: true,
    leaderboardEnabled: true,
    hasProvisionalPhase: true,
    discordRequired: true,
    automaticVerification: true
  },

  requirements: {
    phase1: {
      title: "Phase 1",
      subtitle: "closed beta",
      description: "First 90 Days",
      targets: {
        viewing: {
          metric: "verses",
          minimumPerMonth: 20,
          stretchPerMonth: 30,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        judging: {
          metric: "scorecards",
          minimumPerMonth: 4,
          stretchPerMonth: 7,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        audience: {
          metric: "scorecards",
          minimumPerMonth: 30,
          stretchPerMonth: 45,
          completionThreshold: 0.9,
          timeframe: "total"
        },
        community: {
          metric: "comments",
          minimumPerMonth: 5,
          stretchPerMonth: 10,
          completionThreshold: 0.9,
          timeframe: "weekly"
        }
      }
    },
  
    phase2: {
      title: "Phase 2",
      subtitle: "open beta",
      description: "Remaining Beta",
      targets: {
        viewing: {
          metric: "verses",
          minimumPerMonth: 12,
          stretchPerMonth: 18,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        judging: {
          metric: "scorecards",
          minimumPerMonth: 3,
          stretchPerMonth: 5,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        audience: {
          metric: "scorecards",
          minimumPerMonth: 75,
          stretchPerMonth: 150,
          completionThreshold: 0.9,
          timeframe: "total"
        },
        community: {
          metric: "comments",
          minimumPerMonth: 5,
          stretchPerMonth: 10,
          completionThreshold: 0.9,
          timeframe: "weekly"
        }
      }
    },
    
    phase3: {
      title: 'Phase 3',
      subtitle: 'open beta',
      description: 'Last 90 Days',
      targets: {
        viewing: {
          metric: "verses",
          minimumPerMonth: 20,
          stretchPerMonth: 30,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        judging: {
          metric: "scorecards",
          minimumPerMonth: 4,
          stretchPerMonth: 7,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        audience: {
          metric: "scorecards",
          minimumPerMonth: 30,
          stretchPerMonth: 45,
          completionThreshold: 0.9,
          timeframe: "total"
        },
        community: {
          metric: "comments",
          minimumPerMonth: 5,
          stretchPerMonth: 10,
          completionThreshold: 0.9,
          timeframe: "weekly"
        }
      }
    }
  },

  leaderboard: {
    scope: "day_ones_only",
    metricsWeighted: [
      "battling",
      "judging",
      "audience",
      "community",
      "reputation"
    ],
    thresholdsProvisionalUntilClosedBeta: true
  },

  rewards: {
    shared: [
      "Special perks and bonuses based on community input"
    ],

    provisional: {
      statusId: 'day_one_provisional',
      title: "Provisional",
      subtitle: '',
      description: 'Meet the first 3-month engagement gate to become Provisional Day One. You unlock progressive premium and remain eligible for official status through sustained consistency.',

      recognitions: [
        "Hall of Fame placement",
        "Provisional Day One badge"
      ],

      privileges: [
        "Retain cumulative earned premium",
        "Priority for future community roles"
      ],
      
      premiumUnlocks: [{
        phase: 'phase1',
        months: [1, 2, 3],
        rewards: [{
          type: 'premium',
          monthsLength: 12
        }]
      }, {
        phase: 'phase2',
        months: [4, 5, 6, 7, 8, 9],
        rewards: [{
          type: 'premium',
          monthsLength: 3
        }, {
          type: 'premium',
          monthsLength: 3
        }]
      }, {
        phase: 'phase3',
        months: [10, 11, 12],
        rewards: [{
          type: 'premium',
          monthsLength: 6
        }]
      }]
    },

    runnerUp: {
      statusId: 'day_one_runner_up',
      title: 'Runner-Up',
      subtitle: '',
      description: 'Meet requirements but finish outside the final official cap. Runner-Ups keep cumulative premium unlocks, Hall of Fame recognition, and eligibility for future community opportunities.',

      recognitions: [
        "Hall of Fame placement",
        "Runner-Up Day One marker"
      ],

      privileges: [
        "Retain cumulative earned premium",
        "Priority for future leadership roles"
      ],

      premium: {
        monthsLength: 12,
        isProvisionalRetained: true,
        bonuses: [{
          monthsLength: 12,
          label: '12 months if all beta phases complete'
        }]
      }
    },

    official: {
      statusId: 'day_one_official',
      title: "Day One",
      subtitle: 'official',
      description: "Official Day Ones are selected from the most consistent provisional members at beta close. They receive lifetime role premium, permanent profile recognition, and stronger influence in community direction and feature feedback.",
      
      recognitions: [
        "Lifetime Day One badge",
        "Permanent Hall of Fame profile listing"
      ],

      privileges: [
        "Display Day One title in battle headers",
        "Access Day One advisory polls",
        "Eligibility for leadership roles"
      ],

      premium: {
        monthsLength: -1,
        isProvisionalRetained: false,
        bonuses: []
      }
    }
  },

  progression: {
    provisionalQualification: "meet_first_3_month_requirements",
    officialSelection: {
      method: "top_250_most_consistently_active_at_beta_end",
      tieBreakers: ["completedBattles", "reputation", "judging", "earlierSignupDate"],
      evaluationMetrics: [
        "battling",
        "judging",
        "audience",
        "community",
        "reputation"
      ]
    },

    overflowHandling: {
      statusGranted: "day_one_runner_up",
    }
  },

  verification: {
    trackingSources: [
      "platform_battle_activity",
      "platform_judging_activity",
      "audience_scorecard_tracking",
      "reputation_scores",
      "leaderboard_metrics"
    ],
    manualReviewRequired: false
  },
  
  cardMeta: {
    teasers: [
      "Lifetime premium",
      "Lifetime recognition"
    ],
    highlights: [
      "250 Spots",
      "Commitment",
      "Performance"
    ],
    expectations: [{
      key: 'viewing',
      label: 'Viewing',
      icon: faUsersViewfinder
    }, {
      key: 'judging',
      label: 'Judging',
      icon: faListCheck
    }, {
      key: 'community',
      label: 'Engagement',
      icon: faUsers
    }, {
      key: 'feedback',
      label: 'Feedback',
      icon: faStar
    }]
  },

  confirmationMeta: {
    summaryPoints: [{
        title: "12-Month Engagement Role",
        description: "Performance tracked across viewing, judging, sharing, and engagement"
      },
      {
        title: "Dedicated Day Ones Leaderboard",
        description: "Ranked against Day Ones by engagement metrics"
      },
      {
        title: "Top 500 Official Selection",
        description: "Most consistent members earn official lifetime status"
      },
      {
        title: "Progressive Premium Rewards",
        description: "Earn cumulative premium throughout beta"
      }],
      coreObligations: [{
          title: "Viewing Participation",
          description: "Hit monthly viewing targets"
        },
        {
          title: "Official Judging",
          description: "Complete judging targets with 90% scorecard completion"
        },
        {
          title: "Audience Scorecards",
          description: "Submit tracked audience scorecards separately"
        },
        {
          title: "Sharing & Invites",
          description: "Share weekly or invite monthly"
        },
        {
          title: "Community Engagement",
          description: "Comment and engage in Discord weekly"
        },
        {
          title: "Feedback Contribution",
          description: "Provide meaningful weekly feedback"
        }]
  },

  requiredAcknowledgements: [
    {
      id: 'commitmentPerformanceV1',
      label: 'I understand rewards start at 3 months and status is earned through consistent performance.'
    },
    {
      id: 'trackingAndEligibilityV1',
      label: 'I understand leaderboards track eligibility, contribution, and progression.'
    },
    {
      id: 'communityEngagementV1',
      label: 'I will stay active, contribute to discussions, and participate in Discord during beta.'
    },
    {
      id: 'requirementsAndStatusV1',
      label: 'I understand requirements may evolve and final status depends on performance across all metrics.'
    }
  ],

  registrationSteps: [{
    stepId: 'dayOnesOverview',
    title: 'Role Overview',
    shortTitle: 'Overview',
    description: 'Day Ones are core early adopters shaping SFB through viewing, judging, sharing, and consistent feedback.',
    isBlocking: true,
    contentRendererKey: 'RoleOverviewContent',
    requiredAcknowledgements: [{
      id: 'commitmentV1',
      label: 'I understand this is a performance-based 12-month commitment.'
    }],
  }, {
    stepId: 'DayOnesRequirements',
    title: 'Requirements',
    shortTitle: 'Requirements',
    description: 'Maintain recurring battle activity, judging, scorecards, and weekly engagement to stay eligible.',
    isBlocking: true,
    contentRendererKey: 'RoleRequirementsContent',
    requiredAcknowledgements: [{
      id: 'eligibilityV1',
      label: 'I understand verse totals determine eligibility.'
    }, {
      id: 'scoringV1',
      label: 'I understand official judging and audience scorecards are tracked separately.'
    }, {
      id: 'communityV1',
      label: 'I commit to consistent community engagement.'
    }]
  }, {
    stepId: 'dayOnesRewards',
    title: 'Rewards & Status',
    shortTitle: 'Rewards',
    description: 'Earn progressive premium during beta; official status grants lifetime recognition and benefits.',
    isBlocking: true,
    contentRendererKey: 'RoleRewardsContent',
    requiredAcknowledgements: [{
      id: 'performanceV1',
      label: 'I understand official status is earned based on performance.'
    }]
  }, {
    stepId: 'dayOnesConfirm',
    title: 'Final Confirmation',
    shortTitle: 'Confirm',
    description: "Confirm sustained participation, community standards, and policy updates during beta.",
    isBlocking: true,
    contentRendererKey: 'RoleConfirmationContent',
    requiredAcknowledgements: [{
      id: 'readAllV1',
      label: 'I have read and understand all requirements'
    }, {
      id: 'finalStatusV1', 
      label: 'I understand final status is determined by leaderboard performance'
    }, {
      id: 'discordV1',
      label: 'I agree to participate in Discord during beta'
    }, {
      id: 'thresholdAdjustmentsV1',
      label: 'I understand thresholds may be adjusted before closed beta launch'
    }]
  }]
},

// Influencers
{
  id: "influencers",
  title: "Influencers",
  subtitle: "Creator & Growth",
  isRegistrationOpen: true,
  discordInviteCode: 'D4JPkyenaZ',

  positioning: {
    tagline: "Voices that expand SFB",
    commitmentText: "Content & Promotion Commitment",
    introTeasers: ["create, share, & engage", "top 200 free lifetime premium"],
    shortIntro: 'Influencers with reach and voice in battle rap communities. Raise awareness, spark engagement, and help shape SFB.',
    longIntro: "Influencers & Content Creators expand SFB beyond the core community through consistent battle-related content and promotion. This role combines visibility with accountability: creators are expected to maintain output, drive audience action, and share practical feedback on discoverability and usability. Activity is manually reviewed for quality and consistency. Members who sustain performance through the full beta cycle earn official status, lifetime role premium, and permanent recognition as early growth partners."
  },

  limits: {
    officialCap: 200,
    signupCap: 0
  },

  betaWindow: {
    durationMonths: 12,
    endCondition: "12_months_or_v1_launch"
  },

  flags: {
    isPerformanceBased: true,
    leaderboardEnabled: true,
    hasProvisionalPhase: true,
    discordRequired: true,
    automaticVerification: false
  },

  requirements: {
    phase1: {
      title: "Phase 1",
      subtitle: "open beta",
      description: "First 3 Months",
      targets: {
        content: {
          metric: "posts",
          minimumPerMonth: 8,
          stretchPerMonth: 12,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        promotion: {
          metric: "shares",
          minimumPerMonth: 12,
          stretchPerMonth: 16,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        collaboration: {
          metric: "submissions",
          minimumPerMonth: 1,
          stretchPerMonth: 2,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        community: {
          metric: "contributions",
          minimumPerMonth: 8,
          stretchPerMonth: 12,
          completionThreshold: 0.9,
          timeframe: "monthly"
        }
      }
    },

    phase2: {
      title: "Phase 2",
      subtitle: "open beta",
      description: "Remaining Beta",
      targets: {
        content: {
          metric: "posts",
          minimumPerMonth: 4,
          stretchPerMonth: 8,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        promotion: {
          metric: "shares",
          minimumPerMonth: 8,
          stretchPerMonth: 12,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        collaboration: {
          metric: "submissions",
          minimumPerMonth: 1,
          stretchPerMonth: 2,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        community: {
          metric: "contributions",
          minimumPerMonth: 8,
          stretchPerMonth: 12,
          completionThreshold: 0.9,
          timeframe: "monthly"
        }
      }
    },

    phase3: {
      title: "Phase 3",
      subtitle: "open beta",
      description: "Last 90 Days",
      targets: {
        content: {
          metric: "posts",
          minimumPerMonth: 4,
          stretchPerMonth: 8,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        promotion: {
          metric: "shares",
          minimumPerMonth: 8,
          stretchPerMonth: 12,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        collaboration: {
          metric: "submissions",
          minimumPerMonth: 1,
          stretchPerMonth: 2,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        community: {
          metric: "contributions",
          minimumPerMonth: 8,
          stretchPerMonth: 12,
          completionThreshold: 0.9,
          timeframe: "monthly"
        }
      }
    }
  },

  leaderboard: {
    scope: "influencers_only",
    metricsWeighted: [
      "battling",
      "judging",
      "audience",
      "community",
      "reputation"
    ],
    thresholdsProvisionalUntilClosedBeta: true
  },

  rewards: {
    shared: [
      "Special perks and bonuses based on community input"
    ],

    provisional: {
      statusId: "influencer_provisional",
      title: "Provisional",
      subtitle: "",
      description: "Meet the first 3-month content and promotion gate to become Provisional Influencer. You unlock progressive premium, retain cumulative rewards, and stay eligible for official status through sustained impact.",
      recognitions: [
        "Provisional Influencer recognition",
        "Priority visibility for qualifying content"
      ],
      privileges: [
        "Early influence on creator features",
        "Collaboration on beta campaigns"
      ],
      premiumUnlocks: [
        {
          phase: "phase1",
          months: [1, 2, 3],
          rewards: [{ type: "premium", monthsLength: 12 }]
        },
        {
          phase: "phase2",
          months: [4, 5, 6, 7, 8, 9],
          rewards: [
            {type: "premium", monthsLength: 3 },
            { type: "premium", monthsLength: 3 }
          ]
        },
        {
          phase: "phase3",
          months: [10, 11, 12],
          rewards: [{ type: "premium", monthsLength: 6 }]
        }
      ]
    },

    runnerUp: {
      statusId: "influencer_runner_up",
      title: "Runner-Up",
      subtitle: "",
      description: "Top-performing provisional creators who finish outside the official cap. Runner-Ups retain earned premium, Hall of Fame placement, and recognition for growth impact.",
      recognitions: [
        "Hall of Fame placement",
        "Runner-Up Influencer marker"
      ],
      privileges: [
        "Priority for future creator programs",
        "Advisory access for creator feature feedback"
      ],
      premium: {
        monthsLength: 12,
        isProvisionalRetained: true,
        bonuses: [{
          monthsLength: 12,
          label: "12 months if all beta phases complete"
        }]
      }
    },

    official: {
      statusId: "influencer_official",
      title: "Influencer",
      subtitle: "official",
      description: "Official Influencers are the top 200 most consistent creators at beta close. They receive lifetime role premium, permanent recognition, and direct opportunities to shape discoverability and promotion strategy.",
      recognitions: [
        "Lifetime Influencer badge",
        "Permanent Hall of Fame listing",
        "Recognition in beta leaderboards and channels"
      ],
      privileges: [
        "Early access to creator tools",
        "Collaboration with SFB on campaigns",
        "Display Influencer title across content"
      ],
      premium: {
        monthsLength: -1,
        isProvisionalRetained: false,
        bonuses: []
      }
    }
  },

  progression: {
    provisionalQualification: "meet_first_3_month_requirements",
    officialSelection: {
      method: "top_200_most_consistently_active_at_beta_end",
      tieBreakers: ["reputation", "community", "audience", "earlierSignupDate"],
      evaluationMetrics: [
        "battling",
        "judging",
        "audience",
        "community",
        "reputation"
      ]
    },
    overflowHandling: {
      statusGranted: "influencer_runner_up"
    }
  },

  verification: {
    trackingSources: [
      "manual_review_of_content_creation",
      "promotion_tracking_links",
      "referral_codes",
      "audience_engagement",
      "discord_activity",
      "reputation_scores",
      "leaderboard_metrics"
    ],
    manualReviewRequired: true
  },

  cardMeta: {
    teasers: [
      "Lifetime premium",
      "Creator recognition"
    ],
    highlights: [
      "200 Spots",
      "Commitment",
      "Performance"
    ],
    expectations: [{
      key: "publishing",
      label: "PUblishing",
      icon: faPen
    }, {
      key: "promotion",
      label: "Promotion",
      icon: faBullhorn
    }, {
      key: "community",
      label: "Engagement",
      icon: faUsers
    }, {
      key: "collaboration",
      label: "Feedback",
      icon: faStar
    }]
  },

  confirmationMeta: {
    summaryPoints: [{
      title: "12-Month Creator Role",
      description: "Content and promotion tracked throughout beta"
    }, {
      title: "Dedicated Influencer Leaderboard",
      description: "Ranked by consistency, promotion, and contribution quality"
    }, {
      title: "Top 200 Official Selection",
      description: "Most consistent creators earn official status"
    }, {
      title: "Progressive Premium Rewards",
      description: "Earn cumulative premium across beta phases"
    }],
    coreObligations: [{
      title: "Content Creation",
      description: "Publish battle-related content on schedule"
    }, {
      title: "Promotion Consistency",
      description: "Promote regularly and drive audience participation"
    }, {
      title: "Community Support",
      description: "Support other beta roles in Discord"
    }, {
      title: "Monthly Feedback",
      description: "Provide feedback on discoverability and usability"
    }, {
      title: "Team Collaboration",
      description: "Help test creator and promotion tools"
    }]
  },

  // TODO: Ensure these are aligned with this role.
  requiredAcknowledgements: [
    {
      id: 'commitmentPerformanceV1',
      label: 'I understand rewards start at 3 months and status is earned through consistent performance.'
    },
    {
      id: 'trackingAndEligibilityV1',
      label: 'I understand leaderboards track eligibility, contribution, and progression.'
    },
    {
      id: 'communityEngagementV1',
      label: 'I will stay active, contribute to discussions, and participate in Discord during beta.'
    },
    {
      id: 'requirementsAndStatusV1',
      label: 'I understand requirements may evolve and final status depends on performance across all metrics.'
    }
  ],

  registrationSteps: [{
    stepId: "influencersOverview",
    title: "Role Overview",
    shortTitle: "Overview",
    description: "Influencers & Content Creators grow SFB through consistent content, promotion, and audience-focused feedback.",
    isBlocking: true,
    contentRendererKey: "RoleOverviewContent",
    requiredAcknowledgements: [{
      id: "commitmentV1",
      label: "I understand this is a performance-based 12-month commitment."
    }]
  }, {
    stepId: "influencersRequirements",
    title: "Requirements",
    shortTitle: "Requirements",
    description: "Meet recurring content, promotion, community, and feedback targets to stay eligible.",
    isBlocking: true,
    contentRendererKey: "RoleRequirementsContent",
    requiredAcknowledgements: [{
      id: "eligibilityV1",
      label: "I understand content and promotion consistency determine eligibility."
    }, {
      id: "scoringV1",
      label: "I understand manual verification is used for creator activity and impact."
    }, {
      id: "communityV1",
      label: "I commit to active community participation and monthly feedback."
    }]
  }, {
    stepId: "influencersRewards",
    title: "Rewards & Status",
    shortTitle: "Rewards",
    description: "Earn progressive premium during beta; official status grants lifetime recognition and benefits.",
    isBlocking: true,
    contentRendererKey: "RoleRewardsContent",
    requiredAcknowledgements: [{
      id: "performanceV1",
      label: "I understand official status is earned based on performance."
    }]
  }, {
    stepId: "influencersConfirm",
    title: "Final Confirmation",
    shortTitle: "Confirmation",
    description: "Confirm sustained creator activity, collaboration, and policy updates during beta.",
    isBlocking: true,
    contentRendererKey: "RoleConfirmationContent",
    requiredAcknowledgements: [{
      id: "readAllV1",
      label: "I have read and understand all requirements"
    }, {
      id: "finalStatusV1",
      label: "I understand final status is determined by leaderboard performance"
    }, {
      id: "discordV1",
      label: "I agree to participate in Discord during beta"
    }, {
      id: "thresholdAdjustmentsV1",
      label: "I understand thresholds may be adjusted before closed beta launch"
    }]
  }]
},

// League Hosts
{
  id: "leagueHosts",
  title: "League Hosts",
  subtitle: "League Migration",
  isRegistrationOpen: false,
  discordInviteCode: 'PERQN2R6sG',

  positioning: {
    tagline: "League leaders scaling SFB",
    commitmentText: "Community Migration & Management Commitment",
    introTeasers: ["bring, build, and grow", "free lifetime league features"],
    shortIntro: "League Hosts bring their battlers to SFB, grow beta participation, and help build league management tools.",
    longIntro: "League Hosts are community operators who bring active leagues to SFB and help shape league tools through real usage. Members are expected to migrate users, sustain participation through weekly check-ins, and provide actionable feedback on management workflows. This role directly impacts growth quality and long-term league infrastructure during beta. Hosts who maintain consistency through every phase earn official status, lifetime role premium, and permanent recognition as foundational league partners."
  },

  limits: {
    officialCap: 100,
    signupCap: 150
  },

  betaWindow: {
    durationMonths: 12,
    endCondition: "12_months_or_v1_launch"
  },

  flags: {
    isPerformanceBased: true,
    leaderboardEnabled: true,
    hasProvisionalPhase: true,
    discordRequired: true,
    automaticVerification: false
  },

  requirements: {
    phase1: {
      title: "Phase 1",
      subtitle: "open beta",
      description: "First 3 Months",
      targets: {
        migration: {
          metric: "users",
          minimumPerMonth: 15,
          stretchPerMonth: 20,
          completionThreshold: 0.9,
          timeframe: "total"
        },
        leadership: {
          metric: "check-ins",
          minimumPerMonth: 4,
          stretchPerMonth: 6,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        feedback: {
          metric: "submissions",
          minimumPerMonth: 1,
          stretchPerMonth: 2,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        community: {
          metric: "contributions",
          minimumPerMonth: 8,
          stretchPerMonth: 12,
          completionThreshold: 0.9,
          timeframe: "monthly"
        }
      }
    },

    phase2: {
      title: "Phase 2",
      subtitle: "open beta",
      description: "Remaining Beta",
      targets: {
        migration: {
          metric: "users",
          minimumPerMonth: 10,
          stretchPerMonth: 15,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        monitoring: {
          metric: "check-ins",
          minimumPerMonth: 4,
          stretchPerMonth: 6,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        feedback: {
          metric: "submissions",
          minimumPerMonth: 1,
          stretchPerMonth: 2,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        community: {
          metric: "contributions",
          minimumPerMonth: 8,
          stretchPerMonth: 12,
          completionThreshold: 0.9,
          timeframe: "monthly"
        }
      }
    },

    phase3: {
      title: "Phase 3",
      subtitle: "open beta",
      description: "Last 90 Days",
      targets: {
        migration: {
          metric: "users",
          minimumPerMonth: 10,
          stretchPerMonth: 15,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        monitoring: {
          metric: "checkins",
          minimumPerMonth: 4,
          stretchPerMonth: 6,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        feedback: {
          metric: "submissions",
          minimumPerMonth: 1,
          stretchPerMonth: 2,
          completionThreshold: 0.9,
          timeframe: "monthly"
        },
        community: {
          metric: "contributions",
          minimumPerMonth: 8,
          stretchPerMonth: 12,
          completionThreshold: 0.9,
          timeframe: "monthly"
        }
      }
    }
  },

  leaderboard: {
    scope: "league_hosts_only",
    metricsWeighted: [
      "battling",
      "judging",
      "audience",
      "community",
      "reputation"
    ],
    thresholdsProvisionalUntilClosedBeta: true
  },

  rewards: {
    shared: [
      "Special perks and bonuses based on community input"
    ],

    provisional: {
      statusId: "league_host_provisional",
      title: "Provisional",
      subtitle: "",
      description: "Meet the first 3-month migration and engagement gate to become Provisional League Host. You unlock progressive premium and remain eligible for official status through sustained league growth.",
      recognitions: [
        "Provisional League Host recognition",
        "Visibility as an early migration partner"
      ],
      privileges: [
        "Early influence on league tools",
        "Priority for moderation roles"
      ],
      premiumUnlocks: [
        {
          phase: "phase1",
          months: [1, 2, 3],
          rewards: [{ type: "premium", monthsLength: 12 }]
        },
        {
          phase: "phase2",
          months: [4, 5, 6],
          rewards: [{ type: "premium", monthsLength: 3 }]
        },
        {
          phase: "phase2",
          months: [7, 8, 9],
          rewards: [{ type: "premium", monthsLength: 3 }]
        },
        {
          phase: "phase3",
          months: [10, 11, 12],
          rewards: [{ type: "premium", monthsLength: 6 }]
        }
      ]
    },

    runnerUp: {
      statusId: "league_host_runner_up",
      title: "Runner-Up",
      subtitle: "",
      description: "High-performing provisional hosts who finish outside the final official cap. Runner-Ups retain earned premium, Hall of Fame placement, and recognition for migration impact.",
      recognitions: [
        "Hall of Fame placement",
        "Runner-Up League Host marker"
      ],
      privileges: [
        "Priority for future league pilots",
        "Advisory access for league tooling feedback"
      ],
      premium: {
        monthsLength: 12,
        isProvisionalRetained: true,
        bonuses: [{
          monthsLength: 12,
          label: "12 months if all beta phases complete"
        }]
      }
    },

    official: {
      statusId: "league_host_official",
      title: "League Host",
      subtitle: "official",
      description: "Official League Hosts are the top 100 most consistent hosts at beta close. They receive lifetime league premium, permanent recognition, and elevated influence over league tooling and operations.",
      recognitions: [
        "Lifetime League Host badge",
        "Permanent Hall of Fame listing",
        "Recognition for league growth on SFB"
      ],
      privileges: [
        "Access exclusive league management tools",
        "Display League Host title in interactions",
        "Eligibility for elevated moderation roles"
      ],
      premium: {
        monthsLength: -1,
        isProvisionalRetained: false,
        bonuses: []
      }
    }
  },

  progression: {
    provisionalQualification: "meet_first_3_month_requirements",
    officialSelection: {
      method: "top_100_most_consistently_active_at_beta_end",
      tieBreakers: ["reputation", "community", "audience", "earlierSignupDate"],
      evaluationMetrics: [
        "battling",
        "judging",
        "audience",
        "community",
        "reputation"
      ]
    },
    overflowHandling: {
      statusGranted: "league_host_runner_up"
    }
  },

  verification: {
    trackingSources: [
      "manual_review_of_migrated_users",
      "community_engagement_reports",
      "discord_activity",
      "reputation_scores",
      "leaderboard_metrics"
    ],
    manualReviewRequired: true
  },

  cardMeta: {
    teasers: [
      "Lifetime league premium",
      "League recognition"
    ],
    highlights: [
      "100 Spots",
      "Commitment",
      "Performance"
    ],
    expectations: [{
      key: "migration",
      label: "Migration",
      icon: faPeopleArrows
    }, {
      key: "leadership",
      label: "Leadership",
      icon: faFlag
    }, {
      key: "community",
      label: "Engagement",
      icon: faUsers
    }, {
      key: "feedback",
      label: "Feedback",
      icon: faStar
    }]
  },

  confirmationMeta: {
    summaryPoints: [{
      title: "12-Month League Role",
      description: "Migration, support, and collaboration tracked throughout beta"
    }, {
      title: "Dedicated Host Leaderboard",
      description: "Ranked by migration outcomes and engagement quality"
    }, {
      title: "Top 100 Official Selection",
      description: "Most consistent hosts earn official status"
    }, {
      title: "Progressive Premium Rewards",
      description: "Earn cumulative premium while building community impact"
    }],
    coreObligations: [{
      title: "Community Migration",
      description: "Bring and sustain active users from your channels"
    }, {
      title: "Weekly Check-Ins",
      description: "Monitor activity and maintain participation momentum"
    }, {
      title: "Discord Leadership",
      description: "Lead league discussions and guide members"
    }, {
      title: "Monthly Feedback",
      description: "Submit practical suggestions for league tools"
    }, {
      title: "Team Collaboration",
      description: "Help beta-test league features with SFB"
    }]
  },

  // TODO: Ensure these are aligned with this role.
  requiredAcknowledgements: [
    {
      id: 'commitmentPerformanceV1',
      label: 'I understand rewards start at 3 months and status is earned through consistent performance.'
    },
    {
      id: 'trackingAndEligibilityV1',
      label: 'I understand leaderboards track eligibility, contribution, and progression.'
    },
    {
      id: 'communityEngagementV1',
      label: 'I will stay active, contribute to discussions, and participate in Discord during beta.'
    },
    {
      id: 'requirementsAndStatusV1',
      label: 'I understand requirements may evolve and final status depends on performance across all metrics.'
    }
  ],

  registrationSteps: [{
    stepId: "leagueHostsOverview",
    title: "Role Overview",
    shortTitle: "Overview",
    description: "League Hosts migrate communities to SFB and shape league tools through structured engagement and feedback.",
    isBlocking: true,
    contentRendererKey: "RoleOverviewContent",
    requiredAcknowledgements: [{
      id: "commitmentV1",
      label: "I understand this is a performance-based 12-month commitment."
    }]
  }, {
    stepId: "leagueHostsRequirements",
    title: "Requirements",
    shortTitle: "Requirements",
    description: "Meet recurring migration, monitoring, community, and feedback requirements to stay eligible.",
    isBlocking: true,
    contentRendererKey: "RoleRequirementsContent",
    requiredAcknowledgements: [{
      id: "eligibilityV1",
      label: "I understand migration and activity consistency determine eligibility."
    }, {
      id: "scoringV1",
      label: "I understand manual verification is used for league migration and activity tracking."
    }, {
      id: "communityV1",
      label: "I commit to consistent community leadership and monthly feedback."
    }]
  }, {
    stepId: "leagueHostsRewards",
    title: "Rewards & Status",
    shortTitle: "Rewards",
    description: "Earn progressive premium during beta; official status grants lifetime recognition and benefits.",
    isBlocking: true,
    contentRendererKey: "RoleRewardsContent",
    requiredAcknowledgements: [{
      id: "performanceV1",
      label: "I understand official status is earned based on performance."
    }]
  }, {
    stepId: "leagueHostsConfirm",
    title: "Final Confirmation",
    shortTitle: "Confirmation",
    description: "Confirm migration quality, active community support, and policy updates during beta.",
    isBlocking: true,
    contentRendererKey: "RoleConfirmationContent",
    requiredAcknowledgements: [{
      id: "readAllV1",
      label: "I have read and understand all requirements"
    }, {
      id: "finalStatusV1",
      label: "I understand final status is determined by leaderboard performance"
    }, {
      id: "discordV1",
      label: "I agree to participate in Discord during beta"
    }, {
      id: "thresholdAdjustmentsV1",
      label: "I understand thresholds may be adjusted before closed beta launch"
    }]
  }]
}
];

const defaultExport = {
  DEFAULT_ROLE_WIZARD_DATA,
  BETA_ROLES
};

export default defaultExport;
